<template>

    <section class="justify-content-center mb-4">
        <div class="col-md-12 mx-auto py-2">
            <table class="mx-auto" style="width:100%;">
                <thead>
                    <!-- <tr>
                        <th  class="px-2">
                            <input type="text"
                                style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"
                                :placeholder="__('traductionview.searchbenificiaryname')"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                        </th>
                        <th  class="px-2">
                            <input type="text"
                                style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"
                                :placeholder="__('traductionview.searchprojectname')"
                                v-model="filterproject"
                                @change="onFilterProjectChange()">
                        </th> -->
                        <!-- <th style="vertical-align:middle;" class="text-right">
                            <label for="checkbox" style="font-size:11px;">{{__("traductionview.hidepastproject")}}</label>
                            <input type="checkbox"
                                style="font-size:11px; border: solid 0.5px #3A9AF3; color: #3A9AF3; border-radius: 5px; vertical-align:middle;"
                                id="checkbox"
                                v-model="filterstatus"
                                @change="onFilterStatusChange()">
                        </th>
                    </tr> -->
                </thead>
            </table>
        </div>
        <div class="col-md-12 mx-auto dashboardstyle pt-0">
            <table class="mx-auto text-center abc-table" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom:solid 1px #3A9AF3;">
                        <th class="py-3" style="width:5%; vertical-align:middle;">id</th>
                        <th class="text-left" style="width:30%; vertical-align:middle;">
                           {{__("traductionview.project")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="InvoiceSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="InvoiceSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th v-if="user.super_admin==1" class="text-left" style="width:5%; vertical-align:middle;">
                            {{__("traductionview.pays")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="countrySortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="countrySortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th class="text-left" style="width: 10%; vertical-align:middle;">
                            {{__("traductionview.entrepri")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="clientSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="clientSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width: 10%; vertical-align:middle;">
                            {{__("traductionview.projecttype")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="amountSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="amountSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                            {{__("traductionview.status")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="statusSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="statusSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width: 10%; vertical-align:middle;">
                            {{__("traductionview.stafassigned")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="dateSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="dateSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody id="ongoingproject" style="font-size: 11px; overflow:auto; display:block; max-height:600px;">
                    <tr v-for="(customer, index) in customs" :key="index" style="border-bottom:solid 1px rgb(206,206,206);">
                        <td class="py-3" style="vertical-align: middle; width: 5%;">
                            <!--<a :href="'/app/manager/project/' + customer.id">-->
                                {{ customer.id }}
                            <!--</a>-->
                        </td>
                        <td class="text-left" style="vertical-align: middle; width: 30%;">
                            {{ customer.country.name }}
                        </td>
                        <td v-if="user.super_admin==1" style="vertical-align: middle; width: 10%;">
                            {{ customer.country.name }}
                        </td>
                        <td style="vertical-align: middle; width: 10%;">
                            {{ customer.client.name }}
                        </td>
                        <td style="vertical-align: middle; width: 10%;">
                            {{ customer.status }}
                        </td>
                        <td style="vertical-align: middle; width: 10%; text-transform: capitalize;">
                            {{ customer.amount_usd }}
                        </td>
                        <td style="vertical-align: middle; width: 5%;">
                            {{ customer.date }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>

</template>

<script>
    export default {
        props: [
            'user',
            'country_invoices',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterproject:"",
                filterstatus:"",
            }
        },

        mounted() {
            this.country_invoices.forEach(country_invoice =>
            {
                this.customs.push(country_invoice)
            });
        },


        methods: {
            // onFilterNameChange(){
            //     this.customs=[];
            //     this.customers.forEach(customer =>
            //     {
            //         var search = customer.beneficiary.toLowerCase()
            //         if (search.includes(this.filtername.toLowerCase()))
            //         {
            //             this.customs.push(customer);
            //         }
            //     });

            // },
            // onFilterProjectChange(){
            //     this.customs=[];
            //     this.customers.forEach(customer =>
            //     {
            //         var search = customer.name.toLowerCase()
            //         if (search.includes(this.filterproject.toLowerCase()))
            //         {
            //             this.customs.push(customer);
            //         }
            //     });

            // },
            // onFilterStatusChange(){
            //     this.customs=[];
            //     if (this.filterstatus)
            //     {
            //         this.customers.forEach(customer =>
            //         {
            //             if (customer.progress < "100")
            //             {
            //                 this.customs.push(customer);
            //             }
            //         });

            //     }
            //     else
            //     {
            //         this.customers.forEach(customer =>
            //         {
            //             this.customs.push(customer);
            //         })
            //     }
            // },
            InvoiceSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.id < b.id)
                    {
                        return -1;
                    }
                    else if (a.id > b.id)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            InvoiceSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.id > b.id)
                    {
                        return -1;
                    }
                    else if (a.id < b.id)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            clientSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.client.id < b.client.id)
                    {
                        return -1;
                    }
                    else if (a.client.id > b.client.id)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            clientSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.client.id > b.client.id)
                    {
                        return -1;
                    }
                    else if (a.client.id < b.client.id)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            countrySortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.country < b.country)
                    {
                        return -1;
                    }
                    else if (a.country > b.country)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            countrySortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.country > b.country)
                    {
                        return -1;
                    }
                    else if (a.country < b.country)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            statusSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.status < b.status)
                    {
                        return -1;
                    }
                    else if (a.status > b.status)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            statusSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.status > b.status)
                    {
                        return -1;
                    }
                    else if (a.status < b.status)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            amountSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.amount_usd < b.amount_usd)
                    {
                        return -1;
                    }
                    else if (a.amount_usd > b.amount_usd)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            amountSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.amount_usd > b.amount_usd)
                    {
                        return -1;
                    }
                    else if (a.amount_usd < b.amount_usd)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            dateSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.date < b.date)
                    {
                        return -1;
                    }
                    else if (a.date > b.date)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            dateSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.date > b.date)
                    {
                        return -1;
                    }
                    else if (a.date < b.date)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
    }
}

</script>